
const modules = import.meta.glob('@/docs/markdown/*.md', { as: 'raw', eager: true });

export function getDocContent(slug: string): string | null {
    for (const path in modules) {
        // Handle both relative and absolute paths if necessary, but typically keys are relative to root or as specified
        if (path.endsWith(`/${slug}.md`)) {
             return modules[path] as string;
        }
    }
    return null;
}

export function getDocList(): string[] {
    const list = Object.keys(modules).map(path => {
        return path.split('/').pop()?.replace('.md', '') || '';
    }).filter(Boolean);

    // Custom sort order
    const order = ['Welcome', 'Configuration'];

    return list.sort((a, b) => {
        const indexA = order.indexOf(a);
        const indexB = order.indexOf(b);

        // If both are in the predefined list, sort by index
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }

        // If only A is in the list, it comes first
        if (indexA !== -1) return -1;

        // If only B is in the list, it comes first
        if (indexB !== -1) return 1;

        // Otherwise sort alphabetically
        return a.localeCompare(b);
    });
}
